import classnames from 'classnames/bind';
import { FC, ReactNode } from 'react';
import styles from '../styles.module.scss';

const cx = classnames.bind(styles);

type Props = {
  displayName?: string;
  isSubHeader?: boolean;
  actionButton?: ReactNode;
};
export const HeaderSection: FC<Props> = ({
  displayName,
  isSubHeader = false,
  actionButton,
}) => {
  return (
    <div
      className={cx([
        `headerSectionContainer`,
        {
          headerSubSectionContainer: isSubHeader,
        },
      ])}
    >
      {displayName && (
        <div
          className={cx(['headerText', { headerSubSectionText: isSubHeader }])}
        >
          {displayName}
        </div>
      )}
      {actionButton}
    </div>
  );
};

HeaderSection.displayName = 'HeaderSection';
